import camelCase from "lodash/camelCase";

export const toCamelCase = (...array: (string | number)[]) =>
  camelCase(array.join(" "));
